export function mailTo(mail, text) {
	return `<a href="mailto: ${mail}">${text || mail}</a>`;
}

export function getLink(href, text) {
	return `<a href="${href}">${text || href}</a>`;
}

export function formatLocalizedDate(dateStr, language) {
	const [year, month, day] = dateStr.split('-').map(Number);
	const date = new Date(year, month - 1, day);
	const dateFormatter = new Intl.DateTimeFormat(language, {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
	return dateFormatter.format(date);
}
